import { SelectDesktop } from '@cian/ui-kit';
import { EPublishPeriod } from '../../../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectPublicationDateFilter } from 'shared/selectors/advancedFilters';

export const PublicationDateContainer: FC = () => {
  const { value, options } = useSelector(selectPublicationDateFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (period: EPublishPeriod) => {
      onChange({ action: 'setPublishPeriod', arguments: [period === EPublishPeriod.Any ? null : period] });
    },
    [onChange],
  );

  return <SelectDesktop options={options} value={value} onChange={handleChange} />;
};
